import React from 'react';
import {TextField as FormikTextField} from "formik-material-ui";
import {makeStyles} from "@material-ui/styles";

const useStyles = makeStyles(theme => ({
    textField: {
        width: '100%',
        marginLeft: 'auto',
        marginRight: 'auto',
        paddingBottom: 0,
        marginTop: 0,
        fontWeight: 500,

        borderRadius: 4,
        '& fieldset': {
            border: 'solid #e6e6e6 1px',
        }
    },
    input: {

    },
    label: {
        fontWeight: 600
    }
}));

export default function TextField(props){

    const classes = useStyles();

    const {noLabel, component, required, rootClassName, ...otherProps} = props;

    const TextFieldComponent = component || FormikTextField;

    return (
        <span className={rootClassName}>

            {
                !noLabel && (
                    <span>
                        <span className={classes.label}>{props.label || props.placeholder}</span>
                        { required && (
                            <span className="font-weight-bolder text-danger">&nbsp;&nbsp;(*)</span>
                        )}
                        <br/>
                    </span>
                )
            }
            <TextFieldComponent
                {...otherProps}
                className={`${classes.textField} ${props.className}`}
                InputProps={{...props.InputProps,
                    className: classes.color
                }}
                placeholder={props.placeholder || props.label}
                label={undefined}
                variant={'outlined'}
            />
        </span>
    )
}